import { Slide } from "@jelly/lesson";
import { task as task02 } from "../../../../../task/course-02/lesson-07/task-02";

const task: Slide = {
  title: `Which of the following signals corresponds to the definition of 1 sone?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
